import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const useFeedbackStore = defineStore("feedbackStore", {
  state: () => ({
    feedbacks: [],
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchFeedbacks() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/SiteSettings/GetFeedbacks");

        this.feedbacks = response.data.Payload;
      } catch (error) {
        this.error = "Geri bildirimler alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },
});
